import { all, call, takeLeading, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

import {
  requestRetrieveUserMetrics,
  requestDownloadUserMertics,
  requestRetrieveDealRoomStatistics,
  requestDownloadDealRoomStatistics,
} from './report.actions';
import {
  getRetrieveUserMetricsRequest,
  getDownloadUserMetricsRequest,
  getRetrieveDealRoomStatisticsRequest,
  getDownloadDealRoomStatisticsRequest,
} from './report.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setUserMetrics, setDealRoomStatistics } from '../../slices/report/report.slice';

export function* performRetrieveUserMetricsRequest({ payload }) {
  const { dates } = payload;

  try {
    yield put(addSpinner('Retrieving User Metrics'));

    const [endpoint, options] = getRetrieveUserMetricsRequest(dates);

    const { data } = yield call(axios, endpoint, options);

    delete data.message;
    yield put(setUserMetrics(data));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving User Metrics'));
  }
}

export function* watchForRetrieveUserMetricsRequest() {
  yield takeLeading(requestRetrieveUserMetrics.type, performRetrieveUserMetricsRequest);
}

export function* performDownloadUserMerticsRequest({ payload }) {
  const { dates } = payload;

  try {
    yield put(addSpinner('Downloading User Metrics'));

    const [endpoint, options] = getDownloadUserMetricsRequest(dates);

    const { data } = yield call(axios, endpoint, options);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([data]));

    const date = new Date();
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();
    link.download = `User Metrics Report - ${day}-${month}-${year}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Downloading User Metrics'));
  }
}

export function* watchForDownloadUserMerticsRequest() {
  yield takeLeading(requestDownloadUserMertics.type, performDownloadUserMerticsRequest);
}

export function* performRetrieveDealRoomStatisticsRequest({ payload }) {
  const { dates } = payload;

  try {
    yield put(addSpinner('Retrieving Deal Room Statistics'));

    const [endpoint, options] = getRetrieveDealRoomStatisticsRequest(dates);

    const { data } = yield call(axios, endpoint, options);

    delete data.message;
    yield put(setDealRoomStatistics(data));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving Deal Room Statistics'));
  }
}

export function* watchForRetrieveDealRoomStatisticsRequest() {
  yield takeLeading(requestRetrieveDealRoomStatistics.type, performRetrieveDealRoomStatisticsRequest);
}

export function* performDownloadDealRoomStatisticsRequest({ payload }) {
  const { dates } = payload;

  try {
    yield put(addSpinner('Downloading Deal Room Statistics'));

    const [endpoint, options] = getDownloadDealRoomStatisticsRequest(dates);

    const { data } = yield call(axios, endpoint, options);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([data]));

    const date = new Date();
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();
    link.download = `Deal Room Statistics Report - ${day}-${month}-${year}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Downloading Deal Room Statistics'));
  }
}

export function* watchForDownloadDealRoomStatisticsRequest() {
  yield takeLeading(requestDownloadDealRoomStatistics.type, performDownloadDealRoomStatisticsRequest);
}

export default function* reportSaga() {
  yield all([
    watchForRetrieveUserMetricsRequest(),
    watchForDownloadUserMerticsRequest(),
    watchForRetrieveDealRoomStatisticsRequest(),
    watchForDownloadDealRoomStatisticsRequest(),
  ]);
}
